import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Car, Loader2 } from "lucide-react";

const clean = (p) => (p || "").toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 7);
const isValid = (p) => /^[A-Z]{3}[0-9][A-Z0-9][0-9]{2}$/.test(clean(p));

export function PlateLookupButton({ plate, onFound }) {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/plate-lookup/status").then(({ data }) => setStatus(data)).catch(() => setStatus(null)); }, []);
  if (!status || !status.enabled) { return null; }
  const over = status.used >= status.monthly_limit;
  const bad = !isValid(plate);
  const run = async () => {
    if (bad) { toast.error("Digite a placa primeiro"); return; }
    setBusy(true);
    try {
      const { data } = await api.post(`/plate-lookup/${clean(plate)}`);
      const got = { make: data.make, model: data.model, year: data.year ? Number(String(data.year).match(/\d{4}/)?.[0]) || null : null, year_model: data.year_model ? Number(String(data.year_model).match(/\d{4}/)?.[0]) || null : null, color: data.color, chassi: data.chassi || "" };
      onFound(got);
      setStatus((s) => (s && !data.cached && !data.homolog ? { ...s, used: s.used + 1 } : s));
      toast.success(data.cached ? "Dados recuperados do cache" : data.homolog ? "Dados preenchidos (modo teste)" : "Dados preenchidos pela consulta");
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid="plate-lookup-btn" disabled={busy || bad || over} onClick={run}
      title={over ? "Limite mensal atingido" : "Buscar dados pela placa"} aria-label="Buscar dados pela placa"
      className="mt-2 inline-flex items-center gap-1.5 h-9 px-3 rounded-md bg-green-brand text-white text-xs font-bold uppercase shadow-[0_0_16px_rgba(21,128,61,0.35)] hover:brightness-110 disabled:opacity-40 disabled:shadow-none transition-[filter]">
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Car className="h-4 w-4" />} Buscar dados pela placa <span data-testid="plate-lookup-usage" className="font-mono-caps text-[10px] text-white/80">{status.used}/{status.monthly_limit}</span>
    </button>
  );
}
